import { render, staticRenderFns } from "./ExpedientPeriodicBillingComponent.vue?vue&type=template&id=079f0be8&scoped=true&lang=pug"
import script from "./ExpedientPeriodicBillingComponent.vue?vue&type=script&lang=ts"
export * from "./ExpedientPeriodicBillingComponent.vue?vue&type=script&lang=ts"
import style0 from "./ExpedientPeriodicBillingComponent.vue?vue&type=style&index=0&id=079f0be8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079f0be8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('079f0be8')) {
      api.createRecord('079f0be8', component.options)
    } else {
      api.reload('079f0be8', component.options)
    }
    module.hot.accept("./ExpedientPeriodicBillingComponent.vue?vue&type=template&id=079f0be8&scoped=true&lang=pug", function () {
      api.rerender('079f0be8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/expedients/ExpedientPeriodicBilling/ExpedientPeriodicBillingComponent.vue"
export default component.exports